import { IEnvironment } from './environment';

export const environmentDefault: IEnvironment = {
    alternativeLogo: false,
    // TODO: apiUrl is deprecated. Use apiBaseUrl instead.
    apiUrl: 'https://api-p2p.ergoplatform.com/api/v0',
    apiBaseUrl: 'https://api-p2p.ergoplatform.com',
    apiUrlV1: 'https://api-p2p.ergoplatform.com/api/v1',
    blockchain: {
        coinName: 'Erg',
    },
    defaultLocale: 'en',
    environments: [
        {
            name: 'Mainnet',
            url: 'https://api-p2p.ergoplatform.com',
        },
    ],
    isLoggerEnabled: true,
};
